import { render, staticRenderFns } from "./MetricInfo.vue?vue&type=template&id=2a7b2649&scoped=true"
import script from "./MetricInfo.vue?vue&type=script&lang=js"
export * from "./MetricInfo.vue?vue&type=script&lang=js"
import style0 from "./MetricInfo.vue?vue&type=style&index=0&id=2a7b2649&prod&lang=scss&scoped=true"
import style1 from "./MetricInfo.vue?vue&type=style&index=1&id=2a7b2649&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7b2649",
  null
  
)

export default component.exports